/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';

// 注册
const register = async (name, password) => {
  const rst = await fetchPost('/web_public/register', { name, password });
  return rst;
};

// 登陆
const signin = async (name, password) => {
  const rst = await fetchPost('/web_public/signin', { name, password });
  return rst;
};


export {
  register,
  signin,
};
